import { extendTheme, mergeThemeOverride, Theme } from '@chakra-ui/react';
import { Appearance } from '@stripe/stripe-js';

export const NAVBAR_HEIGHT = 55;

/* @ts-expect-error chakra lies */
export const defaultTheme: Theme & {
  colors: {
    primary: {
      50: string;
      100: string;
      200: string;
      300: string;
      400: string;
      500: string;
      600: string;
      700: string;
      800: string;
      900: string;
    };
  };
} = extendTheme((theme: Theme) =>
  mergeThemeOverride(theme, {
    initialColorMode: 'light',
    useSystemColorMode: false,

    fonts: {
      heading: `'Montserrat', 'Open Sans', sans-serif`,
      body: `'Montserrat', 'Open Sans', sans-serif`,
    },

    styles: {
      global: {
        'html, body': {
          height: '100%',
          color: 'text.main',
          fontSize: '15px',
        },
      },
    },

    colors: {
      // Todo add definitions to /environment.d.ts
      primary: theme.colors.blue,
    },

    shadows: {
      outline: `0 0 0 3px ${theme.colors.blue['200']}`,
    },

    components: {
      FormLabel: {
        baseStyle: {
          m: 1,
        },
      },

      Input: {
        variants: {
          outline: {
            field: {
              borderRadius: 'lg',
              backgroundColor: 'white',
              borderColor: 'blackAlpha.400',
              _hover: {
                borderColor: 'primary.500',
              },
              _focus: {
                borderColor: 'primary.500',
                borderWidth: '2px',
                boxShadow: 'none',
              },
              _placeholder: { color: 'gray.500' },
            },
          },
        },
      },

      Button: {
        variants: {
          solid: {
            fontSize: 'sm',
            _focus: {
              // boxShadow: 'none',
            },
          },

          outline: {
            fontSize: 'sm',
            bg: theme.colors.blackAlpha['50'],
            px: 6,
            _focus: {
              // boxShadow: 'none',
            },
          },

          ghost: {
            fontSize: 'sm',
            _focus: {
              // boxShadow: 'none',
            },
          },
        },
      },

      Table: {
        defaultProps: {
          variant: 'simple',
        },
      },

      IconButton: {
        defaultProps: {
          variant: 'ghost',
        },
      },
    },
  }),
);

export const stripeAppearance: Appearance = {
  theme: 'stripe',

  variables: {
    colorPrimary: '#2b6cb0',
    colorBackground: '#ffffff',
    colorText: 'rgba(0, 0, 0, 0.80)',
    colorDanger: '#E53E3E',
    fontFamily: `'Montserrat', 'Open Sans', sans-serif`,
    borderRadius: '0.5rem',
  },
};
